// Check if user is focused on input or input like elemtns

const INPUTQUERY = "input, textarea, select, [contenteditable='true']";

function isFocusedInput() {
  const active = document.activeElement;
  if (active) {
    // Check if matches return query
    if (active.matches(INPUTQUERY)) {
      return true;
    }
  }

  return false;
}

function isFocusedInputDocument(document) {
  if (!document) {
    return isFocusedInput();
  }
  const active = document.activeElement;
  if (active) {
    // Check if matches return query
    if (active.matches(INPUTQUERY)) {
      return true;
    }
  }

  return false;
}

export { isFocusedInput, isFocusedInputDocument };
